module.exports = __webpack_public_path__ + "img/iOS.19e0fded.png";